import{a as m}from"./chunk-K3ARAMEQ.js";import{f as o,v as r}from"./chunk-I27O7XAY.js";import{m as a}from"./chunk-HBP5N4FR.js";a();r();var g=t=>({egldValueData:{value:t,formattedValue:m({input:t}),decimals:o}});export{g as a};
//# sourceMappingURL=chunk-VSMZ25WQ.js.map
